// The "Create a draft event" offer under a chat answer (Lane 1322, slice D2).
// The server built and signed it after checking the parts; clicking it
// creates the draft event (nothing is sent to any supplier) and opens it.
// Home.js only composes this component.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../../config';
import { formatMoney, formatWindow } from './sourcingApi';
import { GOAL_MAX, GOAL_PICKS, cleanGoal } from './goal';
import './SourcingEventOfferAction.css';

export default function SourcingEventOfferAction({ offer, conversationId, authFetch }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [goal, setGoal] = useState('');
  const p = offer.preview || {};

  const accept = async () => {
    setBusy(true);
    setError('');
    try {
      const r = await authFetch(`${API_BASE}/api/sourcing/offers/accept`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // The goal is optional; the server saves it after the event exists and a
        // goal it cannot save never stops the event (negotiation PLAN section 4).
        body: JSON.stringify({ offer_token: offer.token, conversation_id: conversationId,
          ...(cleanGoal(goal) ? { goal: cleanGoal(goal) } : {}) }),
      });
      const body = await r.json().catch(() => null);
      if (!r.ok) {
        const detail = body && body.detail;
        setError((detail && typeof detail === 'object' && detail.message)
          || (r.status === 404 ? 'Sourcing events are not available here now.'
            : 'The event could not be created. Try again.'));
        setBusy(false);
        return;
      }
      const notice = body.goal && !body.goal.saved ? body.goal.message : '';
      navigate(`/sourcing/${body.event_public_id}`, notice
        ? { state: { goalNotice: notice, goalEvent: body.event_public_id } } : undefined);
    } catch (e) {
      setError('The event could not be created. Try again.');
      setBusy(false);
    }
  };

  return (
    <div className="hm-rptoffer srce-offer" data-testid="srce-event-offer">
      <div className="srce-offer-goal">
        <label className="srce-offer-gl" htmlFor={`srce-goal-${offer.offer_id}`}>What do you want out of this event? (optional)</label>
        <input id={`srce-goal-${offer.offer_id}`} className="srce-offer-gi" value={goal} maxLength={GOAL_MAX}
          disabled={busy} placeholder="Type a goal, or pick one" onChange={(e) => setGoal(e.target.value)} />
        <span className="srce-offer-picks">
          {GOAL_PICKS.map((g) => (
            <button key={g} type="button" className={`srce-offer-pick${cleanGoal(goal) === g ? ' srce-offer-pick--on' : ''}`}
              disabled={busy} onClick={() => setGoal(g)}>{g}</button>
          ))}
        </span>
      </div>
      <button type="button" className="hm-rptoffer-btn" disabled={busy} onClick={accept}>
        {busy ? 'Creating…' : offer.label}
      </button>
      <span className="srce-offer-d">
        {offer.name}: {Number(p.lines || 0).toLocaleString()} lines
        ({Number(p.parts || 0).toLocaleString()} parts at {p.site_count}
        {' '}{p.site_count === 1 ? 'site' : 'sites'}), {formatMoney(p.spend)} spent
        {' '}{formatWindow(p.window)}. Nothing is sent to suppliers.
      </span>
      {error && <span className="hm-rptoffer-fail" role="alert">{error}</span>}
    </div>
  );
}
